import { useLocation } from 'react-router-dom'
import { navLinks } from '../constants/nav'
import { useEffect } from 'react'
import { useActions } from './useActions'

const useDocumentTitle = () => {
	const { pathname } = useLocation()

	const { setPageTitle } = useActions()

	function getPageTitle() {
		let title = ''

		if (pathname === '/sign-in') {
			title = 'Авторизація'
		} else {
			for (const i of navLinks) {
				if (i.path === pathname) {
					title = i.title
					break
				} else if (i?.links?.length) {
					for (const j of i.links) {
						if (j.path === pathname) {
							title = j.title
							break
						}
					}
				} else {
					continue
				}
			}
		}

		return title
	}

	useEffect(() => {
		const pageTitle = getPageTitle()
		document.title = pageTitle
		setPageTitle(pageTitle)
	}, [pathname])
}

export default useDocumentTitle
